import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class VehicleTrackingMapService {
  constructor(public db: AngularFireDatabase, private firestore: AngularFirestore) {}

  public subscribeToLocation(driverId) {
    return this.firestore.collection('driver-states').doc(driverId).valueChanges();
  }
}
